export const isToken = (type) => type === 'ERC-20' || type === 'MiniMe';
//# sourceMappingURL=types.js.map